import styled from 'styled-components';
import { Avatar as AntdAvatar } from 'antd';

export const Avatar = styled(AntdAvatar)``;
